<template>
    <div v-if="isVisible" class="form-item radio" :class="[isInvalid ? 'is-invalid' : '']">
        <Label :item="item" :is-invalid="isInvalid" :errors="errors"/>

        <div class="d-flex">
            <div v-for="answer in answeroptions" :key="answer.id">
                <input type="radio"
                       :id="answer.id"
                       :name="`${item.data.id}[]`"
                       :value="answer.label"
                       @change="change($event, answer)"
                >
                <label :for="answer.id"> {{ answer.label }} </label>
            </div>
        </div>
    </div>
</template>

<script>
import Label from '../components/Label.vue';
import errorMixin from "../mixins/error";
import logicMixin from "../mixins/logic";
import eventBus from "../../formeditor/util/EventBus";
import shuffle from "../util/shuffle";

export default {
    name: 'Paymentmethod',
    components: { Label },
    mixins: [errorMixin, logicMixin],
    props: {
        item: {
            type: Object
        },
        answerOptions: {
            type: Object
        }
    },
    computed: {
        answeroptions() {
            const answeroptions = this.answerOptions[this.item.data.id] ? this.answerOptions[this.item.data.id] : this.item.data.answeroptions;

            if (this.item.data.randomorder) {
                return shuffle(answeroptions);
            }

            return answeroptions;
        }
    },
    mounted() {
        this.item.data.answeroptions.forEach(answer => {
            if(answer.id_default) {
                eventBus.$emit('setValue', this.item.data.id, answer.id);
            }
        });
    },
    methods: {
        change(event, answer) {
            if(event.target.checked) {
                eventBus.$emit('setValue', this.item.data.id, answer.id);
            }
        }
    }
};
</script>